// extracted by mini-css-extract-plugin
export var menuLinks = "link-module--menuLinks--sDmZE";
export var menuLinksActive = "link-module--menuLinksActive--TO3ey";